// Suppress WebGL warnings that don't affect functionality
// These are browser-specific warnings related to Chrome's shared image implementation

export const suppressWebGLWarnings = () => {
  if (typeof window === 'undefined') return;

  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;

  const webglWarningsToSuppress = [
    'GL_INVALID_OPERATION',
    'invalid mailbox name',
    'texture is not a shared image',
  ];

  console.error = (...args: any[]) => {
    const message = args.join(' ');
    const shouldSuppress = webglWarningsToSuppress.some((warning) =>
      message.includes(warning)
    );

    if (!shouldSuppress) {
      originalConsoleError(...args);
    }
  };

  console.warn = (...args: any[]) => {
    const message = args.join(' ');
    const shouldSuppress = webglWarningsToSuppress.some((warning) =>
      message.includes(warning)
    );

    if (!shouldSuppress) {
      originalConsoleWarn(...args);
    }
  };
};
